import { RouteObject } from 'react-router-dom';
import ListPpvResponsive from "../components/ResponsiveWrapper/Ppv/ListPpvResponsive";
import { ListPpvResponsiveLoader } from "../loaders/ListPpvResponsiveLoader";
import ListPpvByYear, { loader as ListPpvYearLoader } from "../pages/ListPpvByYear";
import SinglePpvListYearResponsive from "../components/ResponsiveWrapper/Ppv/SinglePpvListYearResponsive";
import PpvInfo, { loader as GeneralPpvLoader } from "../pages/PpvInfo";
import SpecificPpvResponsive from "../components/ResponsiveWrapper/Ppv/SpecificPpvResponsive";
import SpecificPpvYearInfo, { loader as SpecificPpvLoader } from "../pages/SpecificPpvYearInfo";

export const ppvRoutes: RouteObject = {
  path: 'ppv',
  children: [
    {
      index: true,
      element: <ListPpvResponsive />,
      loader: ListPpvResponsiveLoader
    },
    {
      path: 'byyear/:yearSelected',
      element: <ListPpvByYear />,
      loader: ListPpvYearLoader
    },
    {
      path: ':namePpv',
      element: <SinglePpvListYearResponsive />,
      loader: GeneralPpvLoader
    },
    {
      path: 'specific/:idString',
      element: <SpecificPpvResponsive />,
      loader: SpecificPpvLoader
    },
  ]
};
